require("core-js/modules/es.date.to-string.js");
var _require = require('date-fns'),
  differenceInYears = _require.differenceInYears,
  dateParser = _require.parse;
var _require2 = require('date-fns/locale'),
  fi = _require2.fi;
var _require3 = require('./constants'),
  FEMALE_NATIONAL_ID = _require3.FEMALE_NATIONAL_ID,
  MALE_NATIONAL_ID = _require3.MALE_NATIONAL_ID,
  INVALID = _require3.INVALID,
  VALID = _require3.VALID;
var NATIONAL_ID_REGEX = /(3[01]|[0-2][0-9])(1[0-2]|0[0-9])[0-9]{2}[A-](00[2-9]|[0-8][1-9][0-9]|[1-8][0-9][0-9])[0-9ABCDEFHJKLMNPRSTUVWXY]$/;
var CONTROL_ARRAY = '0123456789ABCDEFHJKLMNPRSTUVWXYZ'.split('');
var LENGTH_REGEX = /^.{11}$/;

/**
 * Returns the checksum for a finnish nationalId, e.g the
 * two last digits in the nationalId
 *
 * This function makes no guarantees on the return value
 * unless the nationalId is first sanitized.
 *
 * @param {string} sanitizedNationalId
 * @return {string} The checksum
 */
var getNationalIdChecksum = function getNationalIdChecksum(sanitizedNationalId) {
  var nationalId = sanitizedNationalId.substring(0, 10);
  var getIndex = function getIndex(id) {
    var number = '';

    // eslint-disable-next-line no-restricted-syntax
    for (var i in id) {
      if (!Number.isInteger(+id[i])) {
        // eslint-disable-next-line no-continue
        continue;
      }
      number += id[i];
    }
    return +number % 31;
  };
  var index = getIndex(nationalId).toString();
  return CONTROL_ARRAY[index];
};
var getAgeFields = function getAgeFields(birthDate) {
  var now = new Date();
  return {
    age: differenceInYears(now, birthDate),
    birthDate: birthDate.toISOString()
  };
};
var checkHasCorrectCenturyToken = function checkHasCorrectCenturyToken(birthDate, centuryToken) {
  var _getAgeFields = getAgeFields(birthDate),
    age = _getAgeFields.age;
  var hasCorrectCenturyToken = !(age > 100 && centuryToken === '-');
  return hasCorrectCenturyToken;
};
var parse = function parse(nationalId) {
  var result = {
    birthDate: null,
    gender: null,
    age: null,
    valid: INVALID,
    nationalId: null,
    error: {
      type: 'genericError',
      message: "Invalid national Id: ".concat(nationalId)
    }
  };
  if (!nationalId || !String(nationalId || '').trim()) {
    result.error.type = 'length';
    result.error.message = 'Empty invalid national Id';
    return result;
  }
  var trimmedNationalId = nationalId.trim();
  if (trimmedNationalId.length !== 11) {
    result.error.type = 'length';
    result.error.message = "Invalid national Id length: ".concat(nationalId);
    return result;
  }

  // eslint-disable-next-line no-useless-escape
  var sanitized = trimmedNationalId.toUpperCase().replace(/[\s\.]/g, '');
  if (!NATIONAL_ID_REGEX.test(sanitized) || !LENGTH_REGEX.test(sanitized)) {
    return result;
  }
  var checksum = getNationalIdChecksum(sanitized);
  if (checksum !== sanitized.substr(-1)) {
    return result;
  }
  var epoch = new Date(0);
  var day = sanitized.substring(0, 2);
  var month = sanitized.substring(2, 4);
  var year = sanitized.substring(4, 6);
  var centuryToken = sanitized.substring(6, 7);
  var genderDigit = Number.parseInt(sanitized.charAt(9), 10);
  var birthday;
  if (centuryToken === '-') {
    birthday = "".concat(day).concat(month, "19").concat(year);
  } else if (centuryToken === 'A') {
    birthday = "".concat(day).concat(month, "20").concat(year);
  }
  var birthDate = dateParser(birthday, 'ddMMyyyy', epoch, {
    locale: fi
  });
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(birthDate)) {
    return result;
  }
  var hasCorrectCenturyToken = checkHasCorrectCenturyToken(birthDate, centuryToken);
  if (!hasCorrectCenturyToken) {
    birthday = "".concat(day).concat(month, "20").concat(year);
    birthDate = dateParser(birthday, 'ddMMyyyy', epoch, {
      locale: fi
    });
    sanitized = sanitized.replace('-', 'A');
  }
  var ageFields = getAgeFields(birthDate);
  result.birthDate = ageFields.birthDate;
  result.gender = genderDigit % 2 === 0 ? FEMALE_NATIONAL_ID : MALE_NATIONAL_ID;
  result.age = ageFields.age;
  result.valid = VALID;
  result.nationalId = sanitized;
  result.error.type = null;
  result.error.message = null;
  return result;
};
module.exports = {
  parse: parse
};